/*
 * <variant-options> — colour swatches + size pills (snippets/0-variant-options.liquid).
 * Used by collection cards, "You may also like" cards and both product pages.
 *
 * Matching is by value text. That is locale-safe: the radio values and the JSON
 * come from the same render, so both are French or both are English. Never
 * compare these values to anything that did not come from the same render.
 *
 * The element dispatches `vo:change` (detail.variant, null = no such combination);
 * the host handler below applies it to the closest [data-vo-host] via data-vo-* hooks.
 */
(function () {
  'use strict';

  function findVariant(variants, values) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i];
      var ok = true;
      for (var j = 0; j < values.length; j++) {
        if (v.opts[j] !== values[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  // A value is available when some *available* variant carries it together with
  // the current selection in every other group.
  function isValueAvailable(variants, values, groupIndex, value) {
    return variants.some(function (v) {
      if (!v.available || v.opts[groupIndex] !== value) return false;
      for (var i = 0; i < values.length; i++) {
        if (i !== groupIndex && values[i] != null && v.opts[i] !== values[i]) return false;
      }
      return true;
    });
  }

  var api = { findVariant: findVariant, isValueAvailable: isValueAvailable };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof window === 'undefined') return;
  window.SushiVariantOptions = api;

  // Horizon's <quantity-selector-component> (PDP only): limit it to what can
  // still be added for this variant — stock minus what is already in the cart —
  // and lock it on a sold-out variant. Uses its public API (updateConstraints,
  // setCartQuantity); serverDisabled* stop it re-enabling the buttons itself.
  function syncQuantity(host, variant) {
    var qs = host.querySelector('quantity-selector-component');
    if (!qs || typeof qs.updateConstraints !== 'function') return;
    var input = qs.querySelector('input[name="quantity"]');
    var buttons = qs.querySelectorAll('button[name="minus"], button[name="plus"]');
    var locked = !(variant && variant.available);
    qs.serverDisabledMinus = locked;
    qs.serverDisabledPlus = locked;
    if (input) input.disabled = locked;
    buttons.forEach(function (b) { b.disabled = locked; });
    if (!variant) return;
    qs.updateConstraints(String(variant.min || 1), variant.max != null ? String(variant.max) : null, String(variant.step || 1));
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        // A later variant change may have happened while this was in flight —
        // only apply the count if the form still targets this variant.
        var idInput = host.querySelector('input[name="id"]');
        if (idInput && String(idInput.value) !== String(variant.id)) return;
        var line = cart.items.filter(function (i) { return i.variant_id === variant.id; })[0];
        if (typeof qs.setCartQuantity === 'function') qs.setCartQuantity(line ? line.quantity : 0);
      })
      .catch(function () {});
  }

  function applyVariant(host, variant, initial) {
    if (initial) { syncQuantity(host, variant); return; }
    var btn = host.querySelector('[data-vo-add]') || host.querySelector('.merch-atc');
    var canAdd = !!(variant && variant.available);
    if (btn) {
      btn.disabled = !canAdd;
      var text = btn.querySelector('.add-to-cart-text__content > span > span');
      var label = canAdd ? host.dataset.voLabelAdd : host.dataset.voLabelSoldout;
      if (text && label) text.textContent = label;
    }
    if (!variant) { syncQuantity(host, null); return; }

    var idInput = host.querySelector('input[name="id"]');
    if (idInput) idInput.value = variant.id;
    syncQuantity(host, variant);

    // Horizon's add-to-cart animation flies this image to the cart; it only
    // refreshes it on its own variant:update, which we don't emit.
    var atcComponent = host.querySelector('add-to-cart-component');
    if (atcComponent && variant.image) atcComponent.setAttribute('data-product-variant-media', variant.image);

    host.querySelectorAll('[data-vo-price]').forEach(function (el) {
      el.textContent = variant.price;
      if (el.dataset.voSaleClass) el.classList.toggle(el.dataset.voSaleClass, !!variant.compare);
    });
    host.querySelectorAll('[data-vo-compare]').forEach(function (el) {
      el.textContent = variant.compare || '';
      el.hidden = !variant.compare;
    });
    host.querySelectorAll('[data-vo-badge]').forEach(function (el) {
      el.textContent = '-' + variant.pct + '%';
      el.hidden = !variant.compare;
    });
    host.querySelectorAll('[data-vo-link]').forEach(function (a) { a.setAttribute('href', variant.url); });

    host.querySelectorAll('[data-vo-media] img').forEach(function (img) {
      if (!('voBaseSrc' in img.dataset)) {
        img.dataset.voBaseSrc = img.getAttribute('src') || '';
        img.dataset.voBaseSrcset = img.getAttribute('srcset') || '';
      }
      if (variant.image) {
        img.removeAttribute('srcset');
        img.src = variant.image;
      } else {
        img.src = img.dataset.voBaseSrc;
        if (img.dataset.voBaseSrcset) img.setAttribute('srcset', img.dataset.voBaseSrcset);
      }
    });

    if (host.dataset.voHost === 'pdp' && window.history && history.replaceState) {
      history.replaceState(history.state, '', variant.url);
    }
  }

  document.addEventListener('vo:change', function (e) {
    var host = e.target.closest('[data-vo-host]');
    if (host) applyVariant(host, e.detail.variant, e.detail.initial);
  });

  // Keep the checked value visible inside its row (scrolls the row only, never
  // the page) — a selected 14th colour must not sit hidden under the fade.
  function revealChecked(sc) {
    var input = sc.querySelector('input:checked');
    var label = input && input.nextElementSibling;
    if (!label) return;
    var l = label.offsetLeft - sc.offsetLeft;
    var r = l + label.offsetWidth;
    // A value wider than the row: show its start, never cut its first letters.
    if (label.offsetWidth >= sc.clientWidth || l < sc.scrollLeft) sc.scrollLeft = Math.max(0, l - 8);
    else if (r > sc.scrollLeft + sc.clientWidth) sc.scrollLeft = r - sc.clientWidth + 28;
  }

  // Row scroller: fades + ‹ › arrows (mouse users can't swipe a row with a
  // hidden scrollbar; touch devices hide the arrows in CSS and just swipe).
  function watchScroller(sc) {
    var track = sc.parentElement;
    var prev = track && track.querySelector('[data-vo-nav="-1"]');
    var next = track && track.querySelector('[data-vo-nav="1"]');
    function upd() {
      var over = sc.scrollWidth > sc.clientWidth + 1;
      var atStart = sc.scrollLeft <= 2;
      var atEnd = !over || sc.scrollLeft + sc.clientWidth >= sc.scrollWidth - 2;
      sc.classList.toggle('is-overflow', over);
      sc.classList.toggle('is-start', atStart);
      sc.classList.toggle('is-end', atEnd);
      if (prev) prev.hidden = !over || atStart;
      if (next) next.hidden = atEnd;
    }
    [prev, next].forEach(function (btn) {
      if (!btn) return;
      btn.addEventListener('click', function () {
        sc.scrollBy({ left: Number(btn.dataset.voNav) * Math.max(60, sc.clientWidth * 0.8), behavior: 'smooth' });
      });
    });
    sc.addEventListener('scroll', upd, { passive: true });
    if ('ResizeObserver' in window) new ResizeObserver(upd).observe(sc);
    upd();
  }

  if (!window.customElements || customElements.get('variant-options')) return;

  customElements.define('variant-options', class extends HTMLElement {
    connectedCallback() {
      if (this._vo) return;
      var data = this.querySelector('script[data-vo-variants]');
      if (!data) return;
      try { this.variants = JSON.parse(data.textContent); } catch (err) { return; }
      this._vo = true;
      this.groups = Array.prototype.slice.call(this.querySelectorAll('[data-vo-group]'))
        .sort(function (a, b) { return a.dataset.voGroup - b.dataset.voGroup; });
      this.addEventListener('change', (e) => {
        if (!e.target.matches('input[type="radio"]')) return;
        var sc = e.target.closest('.vo__scroller');
        if (sc) revealChecked(sc);
        this.update(true);
      });
      this.querySelectorAll('.vo__scroller').forEach(function (sc) { watchScroller(sc); revealChecked(sc); });
      this.update(false);
      // Initial pass: only the quantity limits — everything else is server-rendered.
      // Cards have no quantity selector, so don't leave a promise waiting there.
      var self = this;
      var host = this.closest('[data-vo-host]');
      if (!host || !host.querySelector('quantity-selector-component')) return;
      customElements.whenDefined('quantity-selector-component').then(function () {
        self.dispatchEvent(new CustomEvent('vo:change', {
          bubbles: true,
          detail: { variant: findVariant(self.variants, self.values()), initial: true },
        }));
      });
    }

    values() {
      return this.groups.map(function (g) {
        var checked = g.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }

    update(emit) {
      var values = this.values();
      var variants = this.variants;
      this.groups.forEach(function (g, gi) {
        g.querySelectorAll('input[type="radio"]').forEach(function (input) {
          var label = input.nextElementSibling;
          if (label) label.classList.toggle('is-soldout', !isValueAvailable(variants, values, gi, input.value));
        });
        var sel = g.querySelector('[data-vo-selected]');
        if (sel && values[gi] != null) sel.textContent = values[gi];
      });
      if (emit) {
        this.dispatchEvent(new CustomEvent('vo:change', {
          bubbles: true,
          detail: { variant: findVariant(variants, values) },
        }));
      }
    }
  });
})();
